export const UpperQuadrantAbbreviations = ['UL', 'UR'] as const;
export const LowerQuadrantAbbreviations = ['LL', 'LR'] as const;
export const LeftQuadrantAbbreviations = ['UL', 'LL'] as const;
export const RightQuadrantAbbreviations = ['UR', 'LR'] as const;
export const DisplayOrderQuadrantAbbreviations = [
  'UR',
  'UL',
  'LL',
  'LR',
] as const;

export type TDisplayOrderQuadrantAbbreviations =
  (typeof DisplayOrderQuadrantAbbreviations)[number];

// for the odontogram, we map in 1 -> 2 -> 4 -> 3 order
export const GridOrderQuadrantAbbreviations = ['UR', 'UL', 'LR', 'LL'] as const;
export type TGridOrderQuadrantAbbreviations =
  (typeof GridOrderQuadrantAbbreviations)[number];

export interface ToothSvgComponentProps {
  className?: string;
  findingsFill?: string | null;
  hx?: number;
  wx?: number;
  fill?: string;
  stroke?: string;
}
